import qs from 'qs';
import { ApiPrefixV1, ApiV1Base,  ApiPrefix, ApiBase} from 'util/icwUtility';
import Request from './request';

export const apiGetQCInspectionJobs = async (filters = {}) => {
  const queryString = qs.stringify(
    {
      ...filters
    },
    {
      encodeValuesOnly: false,
      indices: false,
    }
  );
  return Request.call({
    url: `/micro/third-party/inspections${queryString ? `?${queryString}` : ''}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetServiceProvider = async (filters = {}) => {
  return Request.call({
    url: `/inspections/serviceProviders`,
    method: 'GET',
    apiPrefix: `${ApiBase}${ApiPrefix}`,
    params: filters,
  });
};
export const apiGetInspectionTypes = async (filters = {}) => {
  return Request.call({
    url: `/micro/inspections/type-of-services`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    params: filters,
  });
};